import axios from "axios";
import { BACKEND_URL } from "../../config/api";
import { ChatConversation, ChatMessage } from "../../types/features/support/Chat";

export const chatService = {
  async getConversations(
    token: string,
    skip: number = 0,
    limit: number = 200
  ): Promise<{ conversations: ChatConversation[]; total: number }> {
    const response = await axios.get(`${BACKEND_URL}/chat/conversations?skip=${skip}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data;
  },

  async getMessages(
    token: string,
    userId: string,
    skip: number = 0,
    limit: number = 50
  ): Promise<{ messages: ChatMessage[]; total: number }> {
    const response = await axios.get(`${BACKEND_URL}/chat/messages/${userId}?skip=${skip}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data;
  },

  async sendMessage(token: string, userId: string, content?: string, file?: File): Promise<ChatMessage> {
    const formData = new FormData();
    formData.append("user_id", userId);
    if (content) {
      formData.append("content", content);
    }
    if (file) {
      formData.append("file", file);
    }

    const response = await axios.post(`${BACKEND_URL}/chat/admin/send`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data?.data;
  },

  async markAsRead(token: string, userId: string): Promise<void> {
    await axios.put(
      `${BACKEND_URL}/chat/messages/read/${userId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },

  async getUnreadCount(token: string): Promise<number> {
    const response = await axios.get(`${BACKEND_URL}/chat/unread-count`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data?.data?.unread_count || 0;
  },
};
